export default __webpack_public_path__ + "static/media/Sand Siwapron.25fc6ee6.png";